module.exports = __webpack_public_path__ + "img/cloud-upload.be6b20eb.svg";